import { execAdmin } from '@src/apis/reware/utils';

import type {
  PartnerSettings,
  FetchSettingsExecVariables,
  FetchSettingsExecResponse,
} from './types';

export interface FetchSettingsArgs {
  partnerId: number;
}

export const fetchSettings = async ({
  partnerId,
}: FetchSettingsArgs): Promise<PartnerSettings> => {
  const query = `
    query getPartnerSettings($partnerId: Int!) {
      partner(id: $partnerId) {
        lookerServiceConfigured
        settings {
          catalogDataFieldDefinitions
          primaryCurrencyCode
          useAbsoluteValuesForPricing
          takePhotography
          blendedPhotographyImages
          blendedPhotographyImagesMax
        }
      }
    }
  `;

  const data = await execAdmin<FetchSettingsExecVariables, FetchSettingsExecResponse>(
    query,
    { variables: { partnerId } }
  );

  return {
    ...data.partner.settings,
    lookerServiceConfigured: data.partner.lookerServiceConfigured,
  };
};
